import { dateColumn } from "..";

const lastUpdatedAtColumn = (accessor = "updatedAt", Header = "Last Updated On", timezone) =>
  dateColumn(accessor, Header, timezone);

export default lastUpdatedAtColumn;
